module.exports = __webpack_public_path__ + "static/media/federal-mogul-logo.6b8b24ed.png";